<template>
    <div>
      
      <div class="col-md-7 clear-padding">
        <div class="evaluation-wrapper">
          <div class="evaluation-header clearfix cursor-pointer border-top-color-skin" @click="togglePart1">
            <div class="col-xs-8 clear-padding">
              <div class="col-xs-12 col-md-3 clear-padding">ส่วนที่ 1</div>
              <div class="col-xs-12 col-md-9 clear-padding evaluation-title">Title</div>
            </div>
            <div class="col-xs-4 clear-padding evaluation-score">10/20</div>
          </div>

          <div class="evaluation-body" v-show="part1">
            <div class="evaluation-section clearfix">
              <div class="evaluation-item clearfix">
                <div class="col-xs-12 subject">
                    1. It is a long established fact that a reader will be distracted by the readable 
                    content of a page when looking at its layout.
                  </div>
                <div class="col-xs-12 clear-padding">
                  <div class="special">
                    
                  </div>
                  <div class="choice">
                    <div class="col-xs-12 clear-padding radio">
                      <div class="col-xs-2 col-md-1 clear-padding">
                        <input id="radio-1" name="radio" type="radio">
                        <label for="radio-1" class="radio-label"></label>
                      </div>
                      <div class="col-xs-10 col-md-11 box-label" :class="{ 'border-color-skin' : choice1Disp}" @click="toggleChoice1Disp">
                        <div class="main-label" :class="{ 'active color-skin' : choice1Disp}">A : ดีมาก (4 คะแนน)</div>
                        <div class="more-label" v-show="choice1Disp">Contrary to popular belief, Lorem Ipsum is not simply random text.</div>
                      </div>
                    </div>
                    <div class="col-xs-12 clear-padding radio">
                      <div class="col-xs-2 col-md-1 clear-padding">
                        <input id="radio-2" name="radio" type="radio">
                        <label for="radio-2" class="radio-label"></label>
                      </div>
                      <div class="col-xs-10 col-md-11 box-label" :class="{ 'border-color-skin' : choice2Disp}" @click="toggleChoice2Disp">
                        <div class="main-label" :class="{ 'active color-skin' : choice2Disp}">B : ดี (3 คะแนน)</div>
                        <div class="more-label" v-show="choice2Disp">It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old.</div>
                      </div>
                    </div>
                    <div class="col-xs-12 clear-padding radio">
                      <div class="col-xs-2 col-md-1 clear-padding">
                        <input id="radio-3" name="radio" type="radio">
                        <label for="radio-3" class="radio-label"></label>
                      </div>
                      <div class="col-xs-10 col-md-11 box-label" :class="{ 'border-color-skin' : choice3Disp}" @click="toggleChoice3Disp">
                        <div class="main-label" :class="{ 'active color-skin' : choice3Disp}">C : ปานกลาง (2 คะแนน)</div>
                        <div class="more-label" v-show="choice3Disp">Richard McClintock, a Latin professor at Hampden-Sydney College in Virginia.</div>
                      </div>
                    </div>
                    <div class="col-xs-12 clear-padding radio">
                      <div class="col-xs-2 col-md-1 clear-padding">
                        <input id="radio-4" name="radio" type="radio">
                        <label for="radio-4" class="radio-label"></label>
                      </div>
                      <div class="col-xs-10 col-md-11 box-label" :class="{ 'border-color-skin' : choice4Disp}" @click="toggleChoice4Disp">
                        <div class="main-label" :class="{ 'active color-skin' : choice4Disp}">D : พอใช้ (1 คะแนน)</div>
                        <div class="more-label" v-show="choice4Disp">Lorem Ipsum comes from sections 1.10.32 and 1.10.33.</div>
                      </div>
                    </div>
                    <div class="col-xs-12 clear-padding radio">
                      <div class="col-xs-2 col-md-1 clear-padding">
                        <input id="radio-5" name="radio" type="radio">
                        <label for="radio-5" class="radio-label"></label>
                      </div>
                      <div class="col-xs-10 col-md-11 box-label" :class="{ 'border-color-skin' : choice5Disp}" @click="toggleChoice5Disp">
                        <div class="main-label" :class="{ 'active color-skin' : choice5Disp}">F : ต้องปรับปรุง (0 คะแนน)</div>
                        <div class="more-label" v-show="choice5Disp">This book is a treatise on the theory of ethics, very popular during the Renaissance.</div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-xs-12 clear-padding ">
                  <!--<div class="col-xs-2 clear-padding"></div>-->
                  <div class="col-xs-12 clear-padding">
                    <div class="weight-box clearfix">
                      <div class="col-xs-12 col-md-4 weight-content"><i class="fa fa-star"></i> Weight : 1</div>
                      <div class="col-xs-12 col-md-4 weight-content"><i class="fa fa-list-ul"></i> Score : 3</div>
                      <!--<div class="weight-content"><i class="fa fa-star-half-o"></i> Gap : 1</div>-->
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="evaluation-section clearfix">
              <div class="evaluation-item clearfix">
                <div class="col-xs-12 subject">
                    2. It is a long established fact that a reader will be distracted by the readable 
                    content of a page when looking at its layout.
                  </div>
                <div class="col-xs-12 clear-padding">
                  <div class="special">
                    
                  </div>
                  <div class="choice">
                    <div class="col-xs-12 clear-padding radio">
                      <div class="col-xs-2 col-md-1 clear-padding">
                        <input id="radio-1" name="radio" type="radio">
                        <label for="radio-1" class="radio-label"></label>
                      </div>
                      <div class="col-xs-10 col-md-11 box-label" :class="{ 'border-color-skin' : choice1Disp}" @click="toggleChoice1Disp">
                        <div class="main-label" :class="{ 'active color-skin' : choice1Disp}">A : ดีมาก (4 คะแนน)</div>
                        <div class="more-label" v-show="choice1Disp">Contrary to popular belief, Lorem Ipsum is not simply random text.</div>
                      </div>
                    </div>
                    <div class="col-xs-12 clear-padding radio">
                      <div class="col-xs-2 col-md-1 clear-padding">
                        <input id="radio-2" name="radio" type="radio">
                        <label for="radio-2" class="radio-label"></label>
                      </div>
                      <div class="col-xs-10 col-md-11 box-label" :class="{ 'border-color-skin' : choice2Disp}" @click="toggleChoice2Disp">
                        <div class="main-label" :class="{ 'active color-skin' : choice2Disp}">B : ดี (3 คะแนน)</div>
                        <div class="more-label" v-show="choice2Disp">It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old.</div>
                      </div>
                    </div>
                    <div class="col-xs-12 clear-padding radio">
                      <div class="col-xs-2 col-md-1 clear-padding">
                        <input id="radio-3" name="radio" type="radio">
                        <label for="radio-3" class="radio-label"></label>
                      </div>
                      <div class="col-xs-10 col-md-11 box-label" :class="{ 'border-color-skin' : choice3Disp}" @click="toggleChoice3Disp">
                        <div class="main-label" :class="{ 'active color-skin' : choice3Disp}">C : ปานกลาง (2 คะแนน)</div>
                        <div class="more-label" v-show="choice3Disp">Richard McClintock, a Latin professor at Hampden-Sydney College in Virginia.</div>
                      </div>
                    </div>
                    <div class="col-xs-12 clear-padding radio">
                      <div class="col-xs-2 col-md-1 clear-padding">
                        <input id="radio-4" name="radio" type="radio">
                        <label for="radio-4" class="radio-label"></label>
                      </div>
                      <div class="col-xs-10 col-md-11 box-label" :class="{ 'border-color-skin' : choice4Disp}" @click="toggleChoice4Disp">
                        <div class="main-label" :class="{ 'active color-skin' : choice4Disp}">D : พอใช้ (1 คะแนน)</div>
                        <div class="more-label" v-show="choice4Disp">Lorem Ipsum comes from sections 1.10.32 and 1.10.33.</div>
                      </div>
                    </div>
                    <div class="col-xs-12 clear-padding radio">
                      <div class="col-xs-2 col-md-1 clear-padding">
                        <input id="radio-5" name="radio" type="radio">
                        <label for="radio-5" class="radio-label"></label>
                      </div>
                      <div class="col-xs-10 col-md-11 box-label" :class="{ 'border-color-skin' : choice5Disp}" @click="toggleChoice5Disp">
                        <div class="main-label" :class="{ 'active color-skin' : choice5Disp}">F : ต้องปรับปรุง (0 คะแนน)</div>
                        <div class="more-label" v-show="choice5Disp">This book is a treatise on the theory of ethics, very popular during the Renaissance.</div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-xs-12 clear-padding ">
                  <!--<div class="col-xs-2 clear-padding"></div>-->
                  <div class="col-xs-12 clear-padding">
                    <div class="weight-box clearfix">
                      <div class="col-xs-12 col-md-4 weight-content"><i class="fa fa-star"></i> Weight : 1</div>
                      <div class="col-xs-12 col-md-4 weight-content"><i class="fa fa-list-ul"></i> Score : 3</div>
                      <!--<div class="weight-content"><i class="fa fa-star-half-o"></i> Gap : 1</div>-->
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>        
        </div>
      </div>

      <div class="col-md-7 clear-padding">
        <div class="evaluation-sum">
          รวม 50/40
        </div>
      </div>

    </div>
</template>

<script>
export default {
  name: 'evalution',
  data () {
    return {
      part1: true,
      choice1Disp: false,
      choice2Disp: false,
      choice3Disp: false,
      choice4Disp: false,
      choice5Disp: false,
      app: this.$parent.$parent.$parent
    }
  },
  computed: {
    pcDisp () {
      return this.app.pcDisp
    }
  },
  methods: {
    togglePart1 () {
      this.part1 = !this.part1
    },
    toggleChoice1Disp () {
      this.choice1Disp = !this.choice1Disp
    },
    toggleChoice2Disp () {
      this.choice2Disp = !this.choice2Disp
    },
    toggleChoice3Disp () {
      this.choice3Disp = !this.choice3Disp
    },
    toggleChoice4Disp () {
      this.choice4Disp = !this.choice4Disp
    },
    toggleChoice5Disp () {
      this.choice5Disp = !this.choice5Disp
    }
  }
}
</script>

<style src="./style.scss" lang='scss'></style>


// WEBPACK FOOTER //
// component.vue?132240e6